import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Email|Test Modal|';
const sharedProperties: Pick<LocDef, 'shared' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogsEmailsTestModal';
export type SPCatalogsEmailsTestModalLocNames =
	| `${LocNameStart}ContentInstructions`
	| `${LocNameStart}TitleDialog`
	| `${LocNameStart}LabelEmailAddress`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonSentTestEmail`;

export const spCatalogsEmailsTestModalLocs: LocDefs<SPCatalogsEmailsTestModalLocNames> = {
	SPCatalogsEmailsTestModalContentInstructions: {
		defaultValue: `The email sent will use the current settings for the chosen language. Substitution tokens will appear surrounded
	by marker-text to allow you to confirm that they were entered correctly into the system. For example, the token
	"{TOKEN}" would be replaced with ">>>{TOKEN}<<<" in the email. The marker-text is not part of the token.`,
		description: 'Test email instructions',
		displayPath: `${pathStart}Test email instructions`,
		displayType: 'Content',
		legacyName: 'Core/Catalogs.Emails.Details.Content.TestEmailInstructions',
		htmlAllowed: true,
		...sharedProperties,
	},
	SPCatalogsEmailsTestModalTitleDialog: {
		defaultValue: 'Test Email',
		description: 'Modal title',
		displayPath: `${pathStart}Modal title`,
		displayType: 'Title',
		legacyName: 'Core/Catalogs.Emails.Details.Title.TestDialog',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPCatalogsEmailsTestModalLabelEmailAddress: {
		defaultValue: 'Email Address',
		description: 'Label for: Email Address.',
		displayPath: `${pathStart}Email Address`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.TestEmailAddress',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPCatalogsEmailsTestModalButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		legacyName: 'Core/Catalogs.Emails.Details.Button.CancelTest',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPCatalogsEmailsTestModalButtonSentTestEmail: {
		defaultValue: 'Send Test Email',
		description: 'Send Test Email button',
		displayPath: `${pathStart}Send Test Email`,
		displayType: 'Button',
		legacyName: 'Core/Catalogs.Emails.Details.Button.SendTest',
		htmlAllowed: false,
		...sharedProperties,
	},
};

export type SPCatalogsEmailsTestModalLocType = LocMap<SPCatalogsEmailsTestModalLocNames>;
